import React from 'react'
import { graphql, compose } from 'react-apollo'
import _ from 'lodash'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { CATEGORIES } from '../../../../constants'

import { Loader, Form, SelectInput } from '../../../UI'
import { validateRequired } from '../../../../libs/validation'

import UPDATE_LOCAL_TOUR from '../../../../graphql/ActivitySteps/UpdateLocalTourCategories.graphql'
import { NotificationManager } from 'react-notifications'

class CategoryForm extends React.Component {
  componentWillMount() {
    const categories = _.get(this, 'props.data.allLocalTours[0].categories', [])

    this.setState({
      saving: false,
      error: ''
    })

    if (categories && categories.length) {
      this.setState({
        items: categories.map(category => {
          return {
            id: _.uniqueId(),
            category: category
          }
        })
      })
    } else if (this.props.currentSteps.categories) {
      this.setState({
        items: this.props.currentSteps.categories.map(category => {
          return {
            id: _.uniqueId(),
            category: category
          }
        })
      })
    } else {
      this.setState({
        items: [
          {
            id: _.uniqueId(),
            category: null
          }
        ]
      })
    }
  }

  getLanguageOptions = () => {
    const { t } = this.props

    const options = []
    for (let category in CATEGORIES) {
      if (CATEGORIES.hasOwnProperty(category)) {
        options.push({
          label: t('categories:' + category),
          value: category
        })
      }
    }

    return options
  }

  handleSubmit = values => {
    const { updateLocalTour } = this.props
    this.setState({
      saving: true,
      error: ''
    })
    const categories = []
    for (let item in values) {
      if (values.hasOwnProperty(item) && values[item] && item.slice(0, 9) === 'category_') {
        if (categories.indexOf(values[item]) !== -1) {
          this.setState({
            saving: false,
            error: 'Each category must be chosen once'
          })
          return
        }
        categories.push(values[item])
      }
    }

    updateLocalTour({
      variables: {
        id: this.props.currentSteps.id,
        categories: categories
      }
    })
      .then(() => {
        this.setState({
          saving: false
        })
        NotificationManager.success('Categories updated', 'Success', 5000)
        this.props.updateSteps()

        if (this.props.data.allLocalTours && this.props.data.allLocalTours[0]) {
          this.props.history.push(`/activity-steps/${this.props.data.allLocalTours[0].id}/description`)
        } else {
          this.props.history.push('/activity-steps/description')
        }
      })
      .catch(err => NotificationManager.error('Error while updating categories', 'Error', 5000))
  }

  handleAddClick = () => {
    this.setState({
      items: [
        ...this.state.items,
        {
          id: _.uniqueId(),
          category: null
        }
      ]
    })
  }

  handleRemoveClick = id => {
    const items = this.state.items.filter(item => item.id !== id)
    this.setState({ items })
  }

  render() {
    const { t } = this.props
    const { saving } = this.state

    if (this.props.loading) {
      return <Loader showLoader={true} />
    }

    return (
      <div className="steps-screen__form step-form faded-container">
        <div className="steps-screen__form-title">{t('category')}</div>
        <div className="steps-screen__form-subtitle" />
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger steps-submit-btn"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <div className="steps-screen__form-subtitle">{t('category_description_title')}</div>
            <div>
              {this.state.items.map(el => {
                return (
                  <div key={el.id} className="removable-item-row">
                    <SelectInput
                      options={this.getLanguageOptions()}
                      id={`category_${el.id}`}
                      placeholder={t('select_category')}
                      initialValue={el.category}
                      validationFuncs={[validateRequired]}
                      simpleValue
                      clearable={false}
                    />
                    {this.state.items.length > 1 && (
                      <div className="remove-item-link" onClick={() => this.handleRemoveClick(el.id)}>
                        <span className="icon-cancel" /> {t('main:remove')}
                      </div>
                    )}
                  </div>
                )
              })}
              {this.state.error && <small className="text-danger">{this.state.error}</small>}
            </div>
            <div className="add-item-link" onClick={this.handleAddClick}>
              <span className="icon-plus" /> {t('add_category')}
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

const enhance = compose(
  translate('activity_steps', 'categories'),
  graphql(UPDATE_LOCAL_TOUR, {
    name: 'updateLocalTour'
  }),
  withRouter
)

export default enhance(CategoryForm)



// WEBPACK FOOTER //
// src/components/ActivitySteps/Steps/MainInfo/CategoryForm.jsx